const Constants = {
    kAPILogin: "api/Auth/Login",
    kAPIGetGiftCardBalance: "api/UserProfile/GetTevalisBalance",
    kMethodQuadranetLogin: "api/Login",
    kMethodQuadranetUser: "api/User",





    // Tevalis APIs
    kAPIGetPoints: 'CRM/1786/25/Points',
    kAPIGETSites: 'Sites',
    kGetTablesForSite: 'Floorplans/',
    kAPIPayAtTable: "v2/" + "OnlineOrders/TablePaymentRequest?",
    kCompleteTransactionPayAtTable: "v2/" + "OnlineOrders/TablePaymentPost",

    // Static
    kBRAND_PASSWORD_MEMEBERINFO: "ca9087f0-6985-4dd7-b2e0-be088a587d7e",
}

export default Constants;